const columns = [
	{
		label: '프로세스 ID',
		msgKey: 'SWCC000581',
		prop: 'procId',
		width: 200
	},
	{
		label: '프로세스명',
		msgKey: 'SWCC000582',
		prop: 'procName',
		width: 250
	},
	{
		label: '동기화 시간',
		msgKey: 'SWCC000580',
		prop: 'serverName',
		width: 200
	}
];

export default columns;
